import React from "react";

export const ExitIcon = () => {
    return <svg className="menu-common__exit-icon" width="20" height="26" viewBox="0 0 20 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 4V21.5L7 26V0L20 4ZM4.5 22H0V4H4.5V22ZM10 11.5V14H12V11.5H10Z" fill="#86868E"/></svg>;
};


